export const FRONTEND_ALERT_ERROR = 'FRONTEND_ALERT_ERROR';
export const WRONG_ADDRESS = 'Votre adresse est incorrecte ou incomplète.';
export const UNAVAILABLE_ADDRESS = 'Désolé, nous ne livrons pas dans cette zone actuellement.';
export const NO_SHOP_SELECTED_ERROR_MESSAGE = 'Vous devez sélectionner un point de vente.';
export const NO_SHOP_AVAILABLE_ERROR_MESSAGE = 'Malheureusement, aucun magasin n\'est disponible actuellement.';
